// check/uncheck checkbox
r.prototype.check = function (status) {
    return this.map(function (node) {
        node.checked = status;
        return node
    });
};
